import React from 'react';
import { Outlet } from 'react-router-dom';

const MyAccount: React.FC = () => <Outlet />;

export default MyAccount;
